import { map } from 'lodash/fp';

import { ExcessToggleValues } from '../../selectors/select-excess-toggle-values';

// converts hospital excess values coming from product data state as numbers to string based options used for toggling customer state.
const hospitalExcessToOptions = (hospitalExcess: ExcessToggleValues): { text: string; value: string }[] =>
  map(
    (value) => ({
      text: `$${value}`,
      value: `${value}`,
    }),
    hospitalExcess,
  );

export default hospitalExcessToOptions;
